import Input from './Input'
import Hr from './Hr'
import Select from './Select'
import Button, {
    BUTTON_SIZE_BIG,
    BUTTON_STYLE_DELETE,
    BUTTON_STYLE_NORMAL,
    BUTTON_STYLE_SAVE,
    getButtonStyles
} from './Button'
import Checkbox from './Checkbox'
import Textarea from './Textarea'
import { useStore } from '../state/RootStore'
import {resolveEndpoint, toastr, useConfirm} from '../utils'
import { observer } from 'mobx-react-lite'
import { DefaultEditor } from 'react-simple-wysiwyg'
import { values } from 'mobx'

function DeleteButton() {
    const { playerEditStore } = useStore()
    const { confirm, isPending } = useConfirm(() => {
        playerEditStore.delete()
    })

    return <Button
        onClick={(e) => {
            e.stopPropagation()
            confirm()
        }}
        style={BUTTON_STYLE_DELETE}
    >{isPending ? 'Are you sure?' : 'Delete'}</Button>
}

function PlayerForm() {
    const { playerEditStore, entityStore } = useStore()
    const { player } = playerEditStore

    if (!player) {
        return null
    }

    const attemptSubmit = () => {
        if (!player?.isValid) {
            toastr({ text: 'Form is invalid' })

            return
        }

        playerEditStore.save()
    }

    return <div>
        <div className='flex grid lg:grid-cols-2 [&>*]:p-10'>

            <div className='flex flex-col flex-1'>

                <Input
                    name='title'
                    label='Title'
                    placeholder='Title'
                    value={player.title}
                    onChange={e => {
                        player.setTitle(e.target.value)
                    }}
                />

                <Input
                    name='url'
                    label='URL'
                    placeholder='URL'
                    value={player.slug}
                    onChange={e => {
                        player.setSlug(e.target.value)
                    }}
                />

                <Select
                    name='template'
                    label='Template'
                    value={player.template}
                    className='!mb-0'
                    onChange={value => {
                        player.setEnvironment(value)
                    }}
                    options={values(entityStore.templates).map(template => ({
                        key: template.name,
                        value: template.name,
                    }))}
                />

                <Hr spacing/>

                <Input
                    name='header-title'
                    label='Header title'
                    placeholder='Header title'
                    value={player.config.header_title}
                    onChange={e => {
                        player.config.setHeaderTitle(e.target.value)
                    }}
                />

                <DefaultEditor value={player.config.text} onChange={e => {
                    player.config.setText(e.target.value)
                }} className='bg-white text-black' />

                <Hr spacing/>

                <Checkbox
                    name='published'
                    label='Is published'
                    value={player.is_published}
                    onChange={value => {
                        player.setIsPublished(value)
                    }}
                />

                <div className='mt-auto w-full flex gap-4'>
                    <Button
                        onClick={attemptSubmit}
                        disabled={!player.isValid}
                        style={BUTTON_STYLE_SAVE}
                    >
                        {player?.id > -1 ? 'Save' : 'Create'}
                    </Button>

                    {player?.id > -1 && <DeleteButton/>}

                    {player?.id > -1 && <Button
                        onClick={() => {
                            window.open(resolveEndpoint('/' + player.slug), '_blank')
                        }}
                        style={BUTTON_STYLE_NORMAL}
                    >
                        Open
                    </Button>}
                </div>
            </div>

            <div className='flex-1'>

                <Textarea
                    name='embed'
                    label='Embed'
                    placeholder='Embed'
                    value={player.config.embed}
                    className='!mb-0 mt-4'
                    rows={4}
                    onChange={e => {
                        player.config.setEmbed(e.target.value)
                    }}
                />

                <div className='mt-5'>
                    <label
                        className='block mb-2 text-sm font-medium text-expo-white'
                    >
                        Logo
                    </label>
                    <div className='flex flex-col'>
                        <img src={player.config.displayedLogo} className='bg-white p-3 w-1/2' alt='none'/>

                        <div className='w-1/2 flex mt-4'>
                            <input
                                id='logo-upload'
                                type='file'
                                className={getButtonStyles({style: BUTTON_STYLE_SAVE, size: BUTTON_SIZE_BIG})}
                                onChange={e => {
                                    const file = e.target.files[0]

                                    if (file) {
                                        player.config.setLogo(file)
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

export default observer(PlayerForm)
